<template>
  <component :is="component" v-if="component"></component>
</template>

<script>
export default {
  data () {
    return {
      title: this.$route.query.title,
      type: this.$route.query.type,
      component: null
    }
  },
  computed: {
    loader () {
      return () => import(`./component/${this.type}`)
    }
  },
  mounted () {
    this.loader().then(() => {
      this.component = () => this.loader()
    }).catch(() => {
      this.component = () => import(`./component/default`)
    })
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/introduce/detail.vue